import axios from 'axios'
import formatDateForBackend from '../../../utils/formatDateForBackend'
import formatTimeForBackend from '../../../utils/formatTimeForBackend'

export default {
  namespaced: false,
  state: {
    allAvailabilities: {},
    availabilityStatus: -1,
    fetching: false,
  },
  mutations: {
    SET_AVAILABILITY(state, availability) {
      state.allAvailabilities = availability
    },
    SET_AVAILABILITY_STATUS(state, status) {
      state.availabilityStatus = status
    },
    SET_FIRST_AVAILABILITY_FETCH_DONE_TRUE(state) {
      state.fetching = true
    },
  },
  actions: {
    GET_AND_SET_AVAILABILITY({
      commit, rootState, state, dispatch,
    }) {
      if (state.fetching || !rootState.rrsAvailable) {
        return
      }
      commit('SET_FIRST_AVAILABILITY_FETCH_DONE_TRUE')
      commit('SET_AVAILABILITY_STATUS', 0)
      dispatch(
        'GET_AVAILABILITY',
        rootState.booking.pickUp.business.id,
      ).then((res) => {
        commit('SET_AVAILABILITY', res.data.data)
        commit('SET_AVAILABILITY_STATUS', 1)
        state.fetching = false
      })
    },
    GET_AVAILABILITY({ rootState }, businessId) {
      if (!rootState.rrsAvailable) {
        return
      }
      const { booking } = rootState
      return axios.post(`${rootState.api}/vehicles/available`, {
        departure_date: formatDateForBackend(booking.pickUp.date),
        return_date: formatDateForBackend(booking.drop.date),
        departure_time: formatTimeForBackend(booking.pickUp.time),
        return_time: formatTimeForBackend(booking.drop.time),
        departure_business_id: businessId,
      })
    },
  },
  getters: {
    canGetAvailability(state, getters, rootState, rootGetters) {
      return rootGetters['booking/datesAndBusinessReady']
    },
  },
}
